export class CreateImageTipModel {
    projImgtipSurrKey: number;
    file: File;
    userSurrKey: number;
    title: string;
    linkUrl: string;
}

export class ImageTipItemModel {
    projImgtipSurrKey: number;
    createUserId: number;
    createDate: Date;
    updateUserId?: number;
    updateDate?: Date;
    imgtipName: string;
    fileNameOrUrl: string;
    by: string;
    isActive: boolean;
    isDelete: boolean;
    order: number;
    title: string;
}

export class ImageTipListModel {
    itemList: Array<ImageTipItemModel>;
    pageNumber: number;
    pageSize: number;
    totalItemCount: number;
    totalPageCount: number;
}

export class ImageTipListQueryModel {
    textSearch: string;
    pageNumber: number;
    pageSize: number;
    sortColumn: string;
    sortByDesc: boolean;
}